import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Iconify from '../Iconify';
import { useMemo } from 'react';
import '../../css/machines/MachineType.css';

const KNOWN_TYPES = new Set(['Portative', 'Fixe']);

const MachineType = ({ type }) => {
    const { t } = useTranslation();

    const displayType = type && KNOWN_TYPES.has(type) ? type : null;

    const icon = useMemo(() => {
        switch (displayType) {
            case 'Portative':
                return 'clarity:tools-line';
            case 'Fixe':
                return 'mdi:home-city';
            default:
                return null;
        }
    }, [displayType]);

    if (!displayType) {
        return null;
    }

    return (
        <Box className="machine_type_Box">
            <Iconify icon={icon} className="machine_type_icon" />
            <Typography className="machine_type">{t(displayType)}</Typography>
        </Box>
    );
};

export default MachineType;
